// icons
import ArrowRight from 'carbon-icons-svelte/lib/ArrowRight.svelte';
import Purchase from 'carbon-icons-svelte/lib/Purchase.svelte';
import AuditTrail from 'carbon-pictograms-svelte/lib/AuditTrail.svelte';
import CognosAnalytics from 'carbon-pictograms-svelte/lib/CognosAnalytics.svelte';
import CloudGuidelines from 'carbon-pictograms-svelte/lib/CloudGuidelines.svelte';
import ConnectedEcosystem from 'carbon-pictograms-svelte/lib/ConnectedEcosystem.svelte';
import DeepLearning from 'carbon-pictograms-svelte/lib/DeepLearning.svelte';
import PlanningAnalytics from 'carbon-pictograms-svelte/lib/PlanningAnalytics.svelte';

// types
import type { EmptyState } from '$types/EmptyState';

export const emptyState: Record<string, EmptyState> = {
	asinList: {
		description: 'Please try another search query',
		icon: AuditTrail,
		title: 'No results',
	},
	asinListPartial: {
		button: {
			icon: Purchase,
			kind: 'primary',
			title: 'Purchase ASIN Amplify',
		},
		description: 'Purchase ASIN Amplify for access to all auto-ungate ASINs',
		icon: AuditTrail,
		title: 'No results',
	},
	blog: {
		button: {
			href: '/marketplace',
			icon: ArrowRight,
			title: 'View Marketplace',
		},
		description: 'Blogs provide the latest tips for selling on Amazon',
		icon: CloudGuidelines,
		title: 'No blogs',
	},
	changelog: {
		button: {
			href: '/marketplace',
			icon: ArrowRight,
			title: 'View Marketplace',
		},
		description: "Changelogs keep you updated on what's happening around here",
		icon: CloudGuidelines,
		title: 'No changelogs',
	},
	docs: {
		button: {
			href: '/marketplace',
			icon: ArrowRight,
			title: 'View Marketplace',
		},
		description: 'Docs include tutorials, how-tos, and walkthroughs',
		icon: CloudGuidelines,
		title: 'No docs',
	},
	favorites: {
		button: {
			href: '/marketplace',
			icon: ArrowRight,
			title: 'View Marketplace',
		},
		description: 'Favorites help you keep track of leads you like the most',
		icon: ConnectedEcosystem,
		title: 'No favorites',
	},
	notifications: {
		description:
			"Notifications for your account will show up here, but you're all caught up for now",
		icon: PlanningAnalytics,
		title: 'No notifications',
	},
	payments: {
		description: 'Historical payments for your account will show up here',
		icon: CognosAnalytics,
		title: 'No payments',
	},
	portfolio: {
		button: {
			href: '/marketplace',
			icon: ArrowRight,
			title: 'View Marketplace',
		},
		description: 'Your Portfolio is a list of leads purchased from the Marketplace',
		icon: DeepLearning,
		title: 'No leads',
	},
};
